import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import { TeamsTableDefinitionZod } from '../../team/tables';
import { NonSensitiveUsersTableDefinitionZod, UserGroupContextZod } from '../tables';

type Arguments = {
    // only honoured for admins, everybody else gets the own corporation
    corporationId?: string;
    position?: number;
};

export const schemaUserResolver_GetTeamsByCorporation = z.array(
    z.object({
        team: TeamsTableDefinitionZod.extend({ corporationId: schemaId }),
        teamLeader: NonSensitiveUsersTableDefinitionZod.merge(UserGroupContextZod).nullable(),
        teamMembers: z.array(NonSensitiveUsersTableDefinitionZod.merge(UserGroupContextZod)),
    }),
);

export type SchemaUserResolver_GetTeamsByCorporation = z.infer<typeof schemaUserResolver_GetTeamsByCorporation>;

export type UserResolver_GetTeamsByCorporation = Resolver<Arguments, SchemaUserResolver_GetTeamsByCorporation>;
